import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'

// ⏬ Initialise le module d'export
Exporting(Highcharts)

export default Highcharts
